import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Divider, HStack, Text } from "native-base";
import useResponsive from "../../util/useResponsive";
const PregnancyDashDatas = ({ weight, height }) => {
    const { isSmallScreen } = useResponsive();
    return (_jsxs(HStack, Object.assign({ divider: _jsx(Divider, {}), direction: "row", space: isSmallScreen ? 1 : 2 }, { children: [_jsxs(Text, { children: [_jsx(Text, Object.assign({ fontSize: "md", fontWeight: "medium", mr: 1, numberOfLines: 1 }, { children: weight })), "gr"] }), _jsxs(Text, { children: [_jsx(Text, Object.assign({ fontSize: "md", fontWeight: "medium", mr: 1, numberOfLines: 1 }, { children: height })), "cm"] })] })));
};
export default PregnancyDashDatas;
